import API from '../../services/API'
import {
    BURIAL_ACTION_GET_BURIAL,
    BURIAL_ACTION_SAVE_BURIAL,
    BURIAL_GETTER,
    BURIAL_MUTATION_ENTIRE_BURIAL,
    BURIAL_MUTATION_SINGLE_ENTRY
} from './burial-types'

import Vue from 'vue'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        burial: {}
    },

    getters: {
        [BURIAL_GETTER]: state => state.burial
    },

    mutations: {
        [BURIAL_MUTATION_SINGLE_ENTRY] (state, payload) {
            let key = Object.keys(payload)[0]
            Vue.set(state.burial, key, payload[key])
        },
        [BURIAL_MUTATION_ENTIRE_BURIAL] (state, payload) { state.burial = payload }
    },

    actions: {
        [BURIAL_ACTION_GET_BURIAL] ({commit}) {
            API.loadBurial()
                .then((burialData) => { commit(BURIAL_MUTATION_ENTIRE_BURIAL, burialData) })
                .catch((error) => console.log('' + error.message))
        },
        [BURIAL_ACTION_SAVE_BURIAL] ({commit, state}, payload) {
            API.saveBurial(payload)
                .then((burialData) => {
                    OAlert.showSuccess('', i18n.t('feedback.burialSucSave'))
                    commit(BURIAL_MUTATION_ENTIRE_BURIAL, burialData)
                })
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/burial.js